import React, { Fragment } from 'react';
import './FooterContacts.scss';
import { FAQComponent } from '../Components/FAQComponent';

export const FooterContacts = ({ baseImgUrl }) => {
  return (
    <Fragment>
      <div className="footer-contacts__main">
        <h2 className="footer-contacts__title">HOW TO USE</h2>
        <div className="footer-contacts__steps">
          {/* Step 1 */}
          <div className="footer-contacts__step">
            <span className="footer-contacts__step-number">1</span>
            <img
              alt="Wash hands"
              className="footer-contacts__step-img"
              src={`${baseImgUrl}/how-to-use-step-1.webp`}
            />
            <span className="footer-contacts__step-label">Wash your hands</span>
          </div>
          {/* Step 2 */}
          <div className="footer-contacts__step">
            <span className="footer-contacts__step-number">2</span>
            <img
              alt="Take out lens"
              className="footer-contacts__step-img"
              src={`${baseImgUrl}/how-to-use-step-2.webp`}
            />
            <span className="footer-contacts__step-label">Take out the lens</span>
          </div>
          {/* Step 3 */}
          <div className="footer-contacts__step">
            <span className="footer-contacts__step-number">3</span>
            <img
              alt="Insert lens"
              className="footer-contacts__step-img"
              src={`${baseImgUrl}/how-to-use-step-3.webp`}
            />
            <span className="footer-contacts__step-label">Insert the lens</span>
          </div>
          {/* Step 4 */}
          <div className="footer-contacts__step">
            <span className="footer-contacts__step-number">4</span>
            <img
              alt="Close eye"
              className="footer-contacts__step-img"
              src={`${baseImgUrl}/how-to-use-step-4.webp`}
            />
            <span className="footer-contacts__step-label">Close the eye</span>
          </div>
        </div>
        <button
          className="footer-contacts__button"
          onClick={() => {
            window.open('/sg/en/contacts/clear-contactlens/how-to-use', '_blank');
          }}
        >
          SEE FULL STEP BY STEP GUIDE
        </button>
      </div>
      <FAQComponent baseImageUrl={baseImgUrl} />
    </Fragment>
  );
};
